import fuzzysearch from 'fuzzysearch'
import { partition, sortByKey } from '../utility'
import districts from '../data/districts.json'

let once = false

export default {
    data: () => ({
        search: '',
        selected: '',
    }),
    computed: {
        filteredDistricts() {
            if (!this.search) {
                return [...districts].sort(sortByKey('name'))
            }

            const nameOrCode = (search) => (
                ({ name, code }) => (
                    name.toLowerCase().indexOf(search.toLowerCase()) === 0
                    || code.indexOf(search) === 0
                )
            )

            const fuzzy = (search) => (
                ({ name }) => fuzzysearch(search.toLowerCase(), name.toLowerCase())
            )

            const [matches, leftovers] = partition(districts, nameOrCode(this.search))

            // Return exact name or code matches first and then fuzzy matches after
            return [
                ...matches.sort(sortByKey('name')),
                ...leftovers.filter(fuzzy(this.search)).sort(sortByKey('name')),
            ]
        },
    },
    methods: {
        select(option) {
            this.selected = option.code
            this.submit()
        },
        input() {
            this.$refs.search.$refs.dropdown.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        },
        submit() {
            this.$emit('select', this.selected)
        },
    },
    mounted() {
        if (once) {
            this.$refs.search.$refs.input.focus()
        }

        once = true
    },
}
